/**
 * Injects the AppsFlyer PBA Web SDK, gated by OneTrust Targeting Cookies (C0004).
 * @see {@link https://support.appsflyer.com/hc/en-us/articles/360001610038-PBA-Web-SDK-integration-guide}
 */
export function injectAppsFlyerWebSdk() {
  if (document.querySelector(`script[id="${APPS_FLYER_WEB_SDK_SCRIPT_ID}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.id = APPS_FLYER_WEB_SDK_SCRIPT_ID;
  script.type = 'text/plain';
  script.className = ONETRUST_TARGETING_CATEGORY_CLASS;
  script.src = APPS_FLYER_WEB_SDK_SCRIPT_URL;
  script.async = true;

  document.head.appendChild(script);
}

/**
 * Returns the AppsFlyer Web SDK, if available.
 */
export function getAppsFlyerWebSdk(): AppsFlyerWebSdk | undefined {
  return (window as unknown as AppsFlyerWebWindow).AF;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const APPS_FLYER_WEB_SDK_SCRIPT_ID = 'appsflyer-web-sdk';
const APPS_FLYER_WEB_SDK_SCRIPT_URL = '/apps-flyer-web-sdk.js';
const ONETRUST_TARGETING_CATEGORY_CLASS = 'optanon-category-C0004';

// ─── Types ───────────────────────────────────────────────────────────────────

export type AppsFlyerWebSdk = ((...args: unknown[]) => void) & {
  q?: unknown[];
  id?: { pba: { webAppId: string } };
  plugins?: Record<string, unknown>;
};

type AppsFlyerWebWindow = {
  AppsFlyerSdkObject?: string;
  AF?: AppsFlyerWebSdk;
};
